<template>
  <modal-form-helper :data="{isModal: true, title: 'Add users', saveText: 'Add selected users'}">
    <template #body>
      <!--begin::Search-->
      <div id="kt_modal_users_search_handler" data-kt-search-keypress="true" data-kt-search-min-length="2"
           data-kt-search-enter="enter" data-kt-search-layout="inline">
        <!--begin::Form-->
        <form @submit.prevent data-kt-search-element="form" class="w-100 position-relative mb-5" autocomplete="off">
          <!--begin::Hidden input(Added to disable form autocomplete)-->
          <input type="hidden"/>
          <!--end::Hidden input-->
          <!--begin::Icon-->
          <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
          <span
              class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                          transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
										<path
                        d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                        fill="currentColor"/>
									</svg>
								</span>
          <!--end::Svg Icon-->
          <!--end::Icon-->
          <!--begin::Input-->
          <input type="text" @input="searchDebounced" class="form-control form-control-lg form-control-solid px-15"
                 name="search" value=""
                 placeholder="Search by username, full name or email..." data-kt-search-element="input"/>
          <!--end::Input-->
          <!--begin::Spinner-->
          <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5"
                data-kt-search-element="spinner">
									<span class="spinner-border h-15px w-15px align-middle text-muted"></span>
								</span>
          <!--end::Spinner-->
          <!--begin::Reset-->
          <span
              class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none"
              data-kt-search-element="clear">
									<!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
									<span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
											<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                            transform="rotate(-45 6 17.3137)" fill="currentColor"/>
											<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
										</svg>
									</span>
            <!--end::Svg Icon-->
								</span>
          <!--end::Reset-->
        </form>
        <!--end::Form-->
        <!--begin::Wrapper-->
        <div class="py-5">
          <!--begin::Suggestions-->
          <div data-kt-search-element="suggestions">
            <!--begin::Users-->
            <div class="mh-375px scroll-y me-n7 pe-7">
              <div v-if="users.length < 1">No result found</div>
              <div v-for="(user, i) in users" :key="`user_${user.id}`">
                <!--begin::User-->
                <div class="rounded d-flex flex-stack bg-active-lighten p-4" data-user-id="0">
                  <!--begin::Details-->
                  <div class="d-flex align-items-center">
                    <!--begin::Checkbox-->
                    <label class="form-check form-check-custom form-check-solid me-5">
                      <input type="checkbox" v-model="user.checked" :id="`user_${user.id}`" class="form-check-input"/>
                    </label>
                    <!--end::Checkbox-->
                    <!--begin::Avatar-->
                    <div class="symbol symbol-35px symbol-circle">
<!--                      <img alt="Pic" :src="static('metronic/assets/media/avatars/300-6.jpg')"/>-->
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Details-->
                    <div class="ms-5">
                      <label :for="`user_${user.id}`" class="cursor-pointer fs-5 fw-bolder text-gray-900 text-hover-primary mb-2">{{
                          $_.get(user.profile, 'first_name', '--') }} {{
                          $_.get(user.profile, 'last_name', '--')
                        }}</label>
                      <div class="fw-bold text-muted">{{ user.email }}</div>
                    </div>
                    <!--end::Details-->
                  </div>
                  <!--end::Details-->
                </div>
                <!--end::User-->
                <!--begin::Separator-->
                <div class="border-bottom border-gray-300 border-bottom-dashed"></div>
                <!--end::Separator-->
              </div>

            </div>
            <!--end::Users-->

<!--            <div class="mt-10">-->
<!--              <ul class="pagination">-->
<!--                <li class="page-item previous disabled"><a href="#" class="page-link"><i class="previous"></i></a>-->
<!--                </li>-->
<!--                <li class="page-item active"><a href="#" class="page-link">1</a></li>-->
<!--                <li class="page-item "><a href="#" class="page-link">2</a></li>-->
<!--                <li class="page-item "><a href="#" class="page-link">3</a></li>-->
<!--                <li class="page-item "><a href="#" class="page-link">4</a></li>-->
<!--                <li class="page-item "><a href="#" class="page-link">5</a></li>-->
<!--                <li class="page-item "><a href="#" class="page-link">6</a></li>-->
<!--                <li class="page-item next"><a href="#" class="page-link"><i class="next"></i></a></li>-->
<!--              </ul>-->
<!--            </div>-->

          </div>
          <!--end::Suggestions-->
        </div>
        <!--end::Wrapper-->
      </div>
    </template>
  </modal-form-helper>


</template>

<script>
export default {
  props: {
    create_event: {
      default: "user-selected",
    }
  },
  data() {
    return {
      users: [],
    }
  },
  computed: {
    selectedUsers(){
      return _.filter(this.users, {checked: true})
    }
  },
  created() {
    this.searchDebounced = _.debounce((evt) => {
      this.search(evt.target.value)
    }, this.SEARCH_DEBOUNCE_MS)
  },
  mounted() {
    this.search()
  },
  methods: {
    // add(user) {
    //   this.selectedUsers.push(user)
    // },
    selectUSer(user, i){
      if(typeof user.checked === 'undefined'){
        user.checked = false
      }
      const checked = !user.checked
      this.$set(this.users[i], 'checked', checked)
      console.log(this.users)
    },
    create() {
      this.$root.$emit(this.create_event, this.selectedUsers)
      this.$emit('close')
    },
    search(query='') {
      this.$axios.get(this.getUrl("users", "search"), {
        params: {query}
      })
          .then(({data}) => {
            console.log(data)
            this.users = data.data
          })
          .catch(err => this.toastLaraValidation(err))
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>